var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _ellipse, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse2, _path38, _path39, _path40, _path41, _path42, _path43, _ellipse3, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoSearchResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 145,
    viewBox: "0 0 200 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.295 120.188c6.831 5.267-36.815 1.062-95.364 7.303-57.13 6.064-99.932.62-103.88-7.834-1.818-3.851 45.11-8.1 103.88-7.834 59.658.354 75.892-6.64 95.364 8.365z",
    fill: "#DFE1E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.597 118.461H36.084c-3.591 0-6.518-2.913-6.518-6.488V15.019c0-.97.799-1.72 1.73-1.72h131.38c1.33 0 2.439 1.103 2.439 2.427v96.247a6.486 6.486 0 0 1-6.518 6.488z",
    fill: "#F0F2F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.779 18.606H29.566v-4.095c0-2.483 2.041-4.53 4.615-4.53h127.161c2.44 0 4.437 1.96 4.437 4.356v4.27z",
    fill: "#9EA3B7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.544 14.46c0 .67-.457 1.16-.996 1.16-.54 0-.997-.535-.997-1.16 0-.626.457-1.162.996-1.162.54 0 .997.536.997 1.161z",
    fill: "#F0F2F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2 14.46c0 .67-.456 1.16-.996 1.16s-.997-.535-.997-1.16c0-.626.457-1.162.997-1.162s.996.536.996 1.161z",
    fill: "#FFEFC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.853 14.46c0 .67-.457 1.16-.997 1.16s-.997-.535-.997-1.16c0-.626.457-1.162.997-1.162s.997.536.997 1.161z",
    fill: "#FCC35D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.67 54.766h-63.5c-1.284 0-2.303-.831-2.303-1.837v-.306c0-1.007 1.019-1.838 2.303-1.838h63.5c1.284 0 2.302.831 2.302 1.838v.306c.044 1.006-1.018 1.837-2.302 1.837zM135.727 60.737h-93.38c-1.373 0-2.48-.83-2.48-1.837v-.306c0-1.006 1.107-1.837 2.48-1.837h93.38c1.372 0 2.479.83 2.479 1.837v.306c0 1.006-1.107 1.837-2.479 1.837zM119.469 67.372H42.656c-1.55 0-2.789-.83-2.789-1.837v-.306c0-1.006 1.24-1.838 2.79-1.838h76.812c1.549 0 2.789.832 2.789 1.838v.306c.044 1.006-1.24 1.837-2.789 1.837zM90.914 73.344H41.643c-.977 0-1.776-.831-1.776-1.838V71.2c0-1.006.8-1.837 1.776-1.837h49.27c.977 0 1.776.83 1.776 1.837v.306c.045 1.007-.799 1.838-1.775 1.838zM110.807 91.258H41.685a1.823 1.823 0 0 1-1.818-1.838v-.306c0-1.006.798-1.837 1.818-1.837h69.122c1.02 0 1.818.831 1.818 1.837v.306a1.823 1.823 0 0 1-1.818 1.838zM142.254 97.56H43.457c-1.994 0-3.59-.83-3.59-1.837v-.306c0-1.006 1.596-1.837 3.59-1.837h98.797c1.994 0 3.59.831 3.59 1.837v.306c.089 1.007-1.596 1.838-3.59 1.838zM132.312 104.527H43.099c-1.815 0-3.232-.831-3.232-1.837v-.306c0-1.006 1.417-1.837 3.232-1.837h89.213c1.816 0 3.233.831 3.233 1.837v.306c.088 1.006-1.417 1.837-3.233 1.837z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.182 139.444c0-.219.088-.439.176-.614.484-.965 7.967-11.189 8.407-12.944.44-1.755.528-6.098.528-6.098l5.766.921c0 1.009-.924 5.397-2.024 6.932-1.145 1.536-11.532 11.496-11.797 11.979-.088.219-.088.658-.088 1.14 0 .79 0 1.668-.44 1.58-.572-.088-.704-1.799-.528-2.896zM91.555 119.456l2.585 23.498c.178.132.446.308.802.527.803.528 1.65 1.23 1.338 1.45-.357.307-1.605-.483-2.363-.966-.267-.176-.49-.352-.49-.352l-7.712-23.147 5.84-1.01z",
    fill: "#FFEFC8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.413 143.725c.17-.048.256-.24.256-.384.768.576 1.58 1.344 1.28 1.584-.34.335-1.536-.528-2.261-1.056.256 0 .554-.048.725-.144zM67.202 139.692c.082.587.247 1.4.575 1.445.165 0 .288-.045.33-.091 0 .813 0 1.716-.412 1.626-.575-.091-.698-1.851-.493-2.98z",
    fill: "#F36E21"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.888 88.675s-1.904 6.505-3.895 8.526c-1.948 1.978-4.206 1.627-6.64 0-2.435-1.582-1.372-5.23-1.372-5.23s-.841-2.549.974-5.142c1.77-2.637 4.824-1.187 6.64-1.714 1.814-.527.929-1.538 2.168-2.725 1.24-1.187 2.612-.615 2.612-.615l-.487 6.9z",
    fill: "#9EA3B7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.421 73.193s-.088 2.423.353 7.137c.44 4.67 1.541 9.472 2.598 11.41 1.057 1.939 2.07 3.128 3.435 2.16 2.51-1.72 1.278-3.834 1.278-3.834s-2.775-2.379-4.096-6.476c-1.322-4.053-2.775-10.265-2.775-10.265-.044-.617-.793-.132-.793-.132zM95.955 83.743c2.043-2.744 4.086-8.409 4.086-8.409l.622.221s-.755 5.223-2.487 9.428c-1.732 4.248-5.108 8.896-6.218 10.046-1.066 1.151-2.132.266-2.532-.796-.577-1.24-.488-2.523.09-3.32.71-.973 4.44-4.337 6.44-7.17z",
    fill: "#FFEFC8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.65 85.617c-.315 1.47.719 2.494.989 3.385.225.846-.09 1.336-.36 1.647-.27.312-1.888-.133-1.888-.133s1.393 4.853 2.742 4.72c1.304-.134 2.878-4.008 2.878-4.008s-1.619-.089-1.844-.356c-.18-.312-.09-.802.135-1.113.18-.312 1.304.133 1.799-.446.584-.579.045-2.315 0-3.963.045-1.692-.9-2.004-1.664-2.048-1.214-.09-2.428.89-2.787 2.315z",
    fill: "#FFEFC8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.094 84.965c-.261 2.195.87 2.644.87 2.644s.174-.762 1.174-2.107c1-1.344 1.652-1.478 1.652-1.478s.435.179.87.851c.435.627.479 1.703.479 1.703s.826-1.3.478-2.958c-.304-1.703-1.913-1.927-1.913-1.927-1.48-.358-3.35 1.031-3.61 3.272z",
    fill: "#9EA3B7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.356 93.832c-.846-1.534-.312-3.287-.312-3.287l-1.514.745s-.445 3.025-2.137 3.025-2.004-3.507-2.004-3.507l-1.38-.877s-.312 1.929-1.291 2.937c-1.024 1.052-2.316.526-2.316.526s.668 3.463.713 6.05c.044 2.586-.624 6.094-.624 6.094s3.028 2.06 5.789 1.972c2.716-.087 4.007-1.709 4.007-1.709s.267-3.069.89-5.524c.624-2.455 2.182-5.217 2.182-5.217s-1.247.088-2.003-1.228z",
    fill: "#47506B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.186 113.968c-.574-3.96-2.075-8.449-2.075-8.449s-2.43 1.628-5.08 1.496c-2.605-.132-4.548-2.156-4.548-2.156s-2.208 1.76-3.577 5.545c-1.37 3.784-.619 10.164-.619 10.164s3.71 1.453 8.612 1.541c4.903.044 8.127-1.101 8.127-1.101s-.31-3.08-.84-7.04z",
    fill: "#757D99"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.045 72.454s-.654-.647-1.439-.733c-.785-.173-.698-1.855-1.177-1.682-.48.129-.436 1.38.043 2.286.48.905 1.788 1.207 2.312.905.436-.302.261-.776.261-.776zM100.001 75.34s.42-.769 1.214-1.11c.747-.343 0-1.882.56-1.882.561 0 1.028 1.197.841 2.138-.187.94-1.401 1.624-2.101 1.496-.56-.17-.514-.641-.514-.641z",
    fill: "#FFEFC8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.311 36.852H43.037a2.174 2.174 0 0 1-2.174-2.167V29.73c0-1.195.976-2.168 2.174-2.168h109.274c1.197 0 2.174.973 2.174 2.168v4.998c-.045 1.15-1.021 2.123-2.174 2.123z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.633 67.595c-15.43-10.617-19.288-31.72-8.646-47.071A33.953 33.953 0 0 1 96.964 7.119C84.416 5.04 71.203 10.128 63.488 21.276c-10.642 15.395-6.784 36.454 8.646 47.071a33.821 33.821 0 0 0 28.2 4.778c-4.789-.796-9.489-2.61-13.701-5.53z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.83 140.691c.088.662 4.195-.088 4.283-.441.088-.397 0-1.587 0-1.587l-1.545-.089s-2.826 1.588-2.738 2.117zM186.348 139.721s-.309 1.014 0 1.367 4.106.97 4.283.618c.177-.353-3.046-2.117-3.046-2.117l-1.237.132z",
    fill: "#FAA918"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.821 100.735c0 .22-2.516 38.28-2.516 38.28l1.942.221s5.652-30.739 7.506-30.695c1.854.044 10.596 31.665 10.596 31.665l1.413-.176-5.254-38.502-8.212-2.69-5.475 1.897z",
    fill: "#2D344B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.019 88.915c-1.502-5.424-1.06-15.877-1.06-15.877l5.695 6.263s-1.633 7.365-1.103 10.408c.53 3.043 4.238 8.203 4.238 8.203l-.706.573s-5.607-4.145-7.064-9.57zM183.524 103.998l-9.846-2.646-5.43 2.911s.309-6.219-.089-11.158c-.441-4.94-1.545-15.127-.662-16.053.309-.265 1.766-.441 3.709-.53 1.942-.044 4.326 0 6.402.177 2.207.176 4.017.53 4.459.926 1.236 1.28 1.457 26.373 1.457 26.373z",
    fill: "#757D99"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.564 76.699c-.53.617-1.369 1.852-1.987 4.102-1.059 3.748-2.516 10.32-2.516 10.32s-1.369-7.586-1.59-10.718c-.132-1.896.088-3.307.618-3.836 1.987-.088 3.4-.044 5.475.132z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.483 68.54c-.662.662-1.721 6.086-.971 6.483.706.397 2.031-.22 2.252.309.221.529-.089 1.455-.089 1.455s-.662.618.221.838c.839.265 1.855-.794 1.855-.794s-.221-1.587.132-2.734c.309-1.147 1.015-2.25.971-3.66-.176-1.368-2.516-3.705-4.371-1.897z",
    fill: "#FCC35D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.159 68.805c.221.793 4.371.529 4.371.529s-.574 2.25-.353 2.381c.22.133.529-.44.838.089.309.529-.618 1.852-.618 1.852l.309.573s1.06-.838 1.413-2.381c.398-1.5.353-1.853 0-2.426-.309-.573-.618-.53-.618-.53s.883-.44-.706-1.19c-1.501-.75-4.857.309-4.636 1.103z",
    fill: "#F36E21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.535 82.584c2.602-2.672 9.569-5.923 9.569-5.923l-.661 5.254s-5.689 1.56-7.321 2.895c-1.632 1.336-2.778 5.12-2.778 5.12l-.794-.177c0-.045-.661-4.542 1.985-7.17z",
    fill: "#757D99"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.028,
    cy: 39.838,
    rx: 33.887,
    ry: 33.838,
    stroke: "#47506B",
    strokeWidth: 11
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M100.001 72.668c-18.213 4.51-36.649-6.546-41.18-24.677-4.531-18.132 6.575-36.485 24.788-40.996",
    stroke: "#757D99",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m122.922 54.008 12.579 8.274-5.124 7.748-12.58-8.274 5.125-7.748z",
    fill: "#47506B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m181.366 107.554-50.732-33.422c-1.773-1.151-2.26-3.542-1.108-5.312l4.386-6.685c1.152-1.77 3.545-2.257 5.317-1.106l50.733 33.422c1.772 1.15 2.26 3.541 1.108 5.312l-4.387 6.684c-1.196 1.771-3.545 2.258-5.317 1.107z",
    fill: "#47506B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.146 97.361s-.131.723.132 1.148c.307.382 2.895 2.209 3.421 1.572.527-.637-2.149-2.337-2.149-2.337s.702 0 .789-.383c.088-.297-1.535 0-1.535 0h-.658z",
    fill: "#FCC35D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.756 103.965c-.798 1.192-2.879 1.192-4.695 0L133.06 69.797c-1.816-1.192-2.658-3.134-1.86-4.326l2.967-4.503c.798-1.192 2.879-1.192 4.695 0l52.001 34.168c1.816 1.192 2.658 3.135 1.86 4.327l-2.967 4.502z",
    fill: "#757D99"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m133.973 75.998-4.32-2.867c-1.102-.75-1.41-2.25-.705-3.352l5.906-8.953c.75-1.103 2.248-1.411 3.35-.706l4.32 2.867-8.551 13.01z",
    fill: "#9EA3B7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m187.945 92.916 2.734 1.778c2.062 1.332 2.645 4.13 1.255 6.174l-3.586 5.376c-1.523 2.31-4.706 2.976-7.037 1.421l-2.241-1.466 8.875-13.282z",
    fill: "#DFE1E7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.756 103.965c-.798 1.192-2.879 1.192-4.695 0L133.06 69.797c-1.816-1.192-2.658-3.134-1.86-4.326l2.967-4.503c.798-1.192 2.879-1.192 4.695 0l52.001 34.168c1.816 1.192 2.658 3.135 1.86 4.327l-2.967 4.502z",
    fill: "#47506B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.983 81.397c-.926 1.057-.882 4.404 1.147 6.826 2.029 2.423 3.925 2.995 4.234 4.36.309 1.322-.441 9.514-.441 9.514l.838.44s3.308-8.368 2.911-10.834c-.397-2.466-4.852-9.601-5.734-10.394-.838-.925-2.117-.88-2.955.088z",
    fill: "#9EA3B7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.883 103.2c-.139.044-2.49.611-2.121.959.415.349 1.291.48 2.029.262.737-.218.922-.872.922-.872l-.83-.349z",
    fill: "#FCC35D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.981 78.556c-.923 1.281-.879 5.256 1.142 8.216 2.021 2.914 3.91 3.621 4.217 5.211.308 1.59-.483 11.395-.483 11.395l.835.486s3.338-10.07 2.987-13.073c-.352-3.004-4.745-11.572-5.623-12.5-.967-.927-2.24-.839-3.075.266z",
    fill: "#757D99"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.491 36.852h-9.436c-1.208 0-2.192-.973-2.192-2.167V29.73c0-1.195.984-2.168 2.192-2.168h9.436v9.289z",
    fill: "#C6C9D5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.925,
    cy: 31.921,
    rx: 1.738,
    ry: 1.81,
    stroke: "#47506B",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m47.508 32.693.653.448-.264.415-.652-.448.263-.415z",
    fill: "#47506B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.183 34.545-1.216-.86a.507.507 0 0 1-.13-.588.462.462 0 0 1 .564-.135l1.217.86a.507.507 0 0 1 .13.587c-.13.226-.391.272-.565.136z",
    fill: "#47506B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.242 89.183c0-.131 2.118-2.764 3.019-5.791.901-3.028 1.757-6.757 1.757-6.757s-2.027-2.633-1.757-2.94c.316-.263 2.749 2.238 2.929 2.94.18.702-.451 6.976-.541 8.775-.09 1.8-3.559 9.829-3.559 9.829l-1.307-.527-.541-5.529z",
    fill: "#FFE6AA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.163 142.346s-.46 1.187-.184 1.484c.276.297 2.901.17 2.901-.042.046-.255-1.888-1.315-1.888-1.315l-.829-.127zM120.749 142.767c-.131.493-.262 1.389 0 1.524.262.134 2.882-.045 2.838-.314-.044-.269-1.965-1.299-1.965-1.299l-.873.089z",
    fill: "#47506B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m134.169 142.502-1.157.044s-1.423-12.234-2.401-14.038c-.978-1.805-4.98-10.298-4.98-10.298s.844 6.909.088 10.122c-.755 3.212-3.824 14.258-3.824 14.258l-1.023.088s.223-9.022.178-12.674c-.044-3.037-1.2-10.298-1.112-14.742 0-.88.089-1.673.223-2.245a6.731 6.731 0 0 1 1.467-3.036c1.068-1.32 2.268-1.804 2.268-1.804l7.738.704s3.869 16.194 3.913 18.174c.045 2.069-1.378 15.447-1.378 15.447z",
    fill: "#47506B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m124.589 110.831 4.316.517-.578 3.151-2.225 1.639-2.18-1.38.667-3.927zM122.591 110.565l-1.054 4.246-1.603.664c0-.885.091-1.681.229-2.256.275-1.327.87-2.3 1.512-3.052l.916.398z",
    fill: "#757D99"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.965,
    cy: 2.966,
    rx: 2.965,
    ry: 2.966,
    transform: "rotate(-49.997 156.133 -89.25) skewX(.082)",
    fill: "#FFCDAB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m129.552 89.267 1.012 3.707-2.99.274.184-3.477 1.794-.504z",
    fill: "#FFCDAB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.579 91.386c.571-.178 2.462-.357 4.791.847 2.374 1.158 3.517 2.629 3.824 4.634.264 2.005-1.802 2.763-1.802 2.763s-1.187 4.412-1.45 6.15c-.264 1.738-.176 3.387-.176 3.387s0 .445-4.264.312c-4.264-.134-3.868-1.025-3.868-1.025s.176-6.908.132-8.913c-.044-2.005-.176-5.57-.176-5.57l2.989-2.585z",
    fill: "#757D99"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.631 83.313c-1.246-1.065-2.982-1.553-4.807-.133-.98.754-1.558 2.218-1.914 3.372-.267.931-.134 1.952-.891 2.395-.489.311-1.736 1.376-2.181 2.174-.356.622.134 2.219 0 2.707-.178.576-1.068 1.641-1.068 2.173 0 1.065 1.068 1.065-1.647 3.816-1.914 1.908-.045 3.327.534 3.815.49.355.401 2.352.668 2.928.445.843 1.113 1.597 2.092 1.864 1.068.266 1.958-.133 2.626-.666a2.77 2.77 0 0 1 1.558-.621c1.157-.044 2.448-.621 3.65-2.351 2.048-2.928 1.514-5.99.802-7.897-.446-1.242-.312-2.618.267-3.771.4-.754.845-1.73 1.246-2.795 1.024-2.75.979-5.324-.935-7.01z",
    fill: "#FCC35D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.626 83.52c-1.244-1.056-.044 1.892-1.867 3.3-.977.748-.577 2.376-.888 3.52-.267.924.266 3.96-.445 4.4-.489.308-1.333 2.288-1.778 3.08-.355.616-1.644.836-1.778 1.32-.177.572-.444 2.2 0 2.64.756.748 3.112 1.32-.444 3.08-2.445 1.188-1.067 1.32-.444 1.76.488.352-.312.308 0 .88.444.836-2.489.66-1.512.924 1.067.264 1.956-.132 2.623-.66a2.775 2.775 0 0 1 1.555-.616c1.156-.044 2.445-.616 3.645-2.332 2.044-2.904 1.511-5.94.8-7.832-.445-1.232-.311-2.596.267-3.74.4-.748.844-1.716 1.244-2.772.978-2.728.933-5.28-.978-6.952z",
    fill: "#FAA918"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.135 92.953c-.887.613-3.059 4.377.044 4.596 3.103.219 9.487-2.67 10.595-3.195 1.108-.482 6.96-5.778 6.96-5.778s3.192-.262 3.413-.744c.222-.481-3.191-.7-3.191-.7s.709-1.182.221-1.182c-.487 0-1.33 2.013-1.33 2.013s-5.718 2.933-7.314 3.458c-5.763 1.839-8.955 1.226-9.398 1.532z",
    fill: "#FFE6AA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/noSearchResults.2f2bdff12b3dc4afc513b0d7373a601d.svg";
export { ForwardRef as ReactComponent };